import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { search: String }
  static targets = ["query"]

  connect() {
    if (this.hasSearchValue) {
      this.loadResults()
    }
  }

  loadResults() {
    this.queryTarget.value = this.searchValue
    var form = $(this.queryTarget).closest("form").get(0)
    form.requestSubmit()
  }
}
